import consumer from "./consumer"

window.closeAlertsChannel = function(channel) {
  if (channel !== null) {
    consumer.subscriptions.remove(channel);
  }
  return null;
}

window.openAlertsChannel = function() {
  
  return consumer.subscriptions.create(
    { channel: "AlertsChannel" },
    {
      connected() {
        // Called when the subscription is ready for use on the server
        console.log("Connected to the alerts channel!")
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
        console.log("Disconnected from alerts")
      },
      
      received(data) {
        
        if (data.being_reviewed_by) {
          /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
          * Someone is starting to review an alert
          * If it is me then add the user-edit icon to the alert, otherwise remove it from the list.
          * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
          */
          let el = document.getElementById('review-alerts-list');
          
          if (el) {
            let alert = el.querySelector('.alert[data-id="' + data.id + '"]');
            
            if (alert) {
              if (el.dataset.userId == data.being_reviewed_by) {
                alert.querySelector('.editing-button').classList.remove('is-hidden');
              }
              else {
                alert.style.opacity = '0';
                setTimeout(function() {alert.remove();}, 350);
              }
            }
          }
        }

        if (data.to_review) {
          /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
          * A held alert has been created so add it to any open review panels
          * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
          */
          let el = document.getElementById('review-alerts-list');
          
          el.insertAdjacentHTML('beforeend', data.to_review);
        }

        if (data.to_release) {
          /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
          * Held alerts have been released so remove them from any open review panels
          * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
          */
          let el = document.getElementById('review-alerts-list');
          
          if (el) {
            data.to_release.forEach(function(id) {
              let alert = el.querySelector('.alert[data-id="' + id + '"]');
              
              if (alert) {
                alert.style.opacity = '0';
                setTimeout(function() {alert.remove();}, 350);
              }
            });
          }
        }

      }
    }
  ) 

}
